export default function SectionTitle({ eyebrow, title, description, align = "left" }) {
  return (
    <div className={`mb-7 ${align === "center" ? "mx-auto max-w-3xl text-center" : "max-w-3xl"}`}>
      {eyebrow && <p className="mb-2 text-xs font-extrabold uppercase tracking-wider text-primary sm:text-sm">{eyebrow}</p>}
      <h2 className="text-2xl font-bold leading-snug text-dark sm:text-3xl lg:text-[32px]">{title}</h2>
      {description && <p className="mt-3 text-base leading-7 text-body">{description}</p>}
    </div>
  );
}
